// @flow

/**
 * Hook that wraps submitFeedback with contextual metadata.
 * Metadata is gathered from OrganisationContext (org name)
 * and auth-pkg-user (impersonation status).
 *
 * This is the single location for feedback metadata construction (DRY).
 */

import { useMemo } from 'react';
import { useOrganisation } from '../context/OrganisationContext';
import { getAuthPkgUser } from '../../../services/auth-pkg-user';
import { submitFeedback } from '../../ai-reports/chat/services/feedbackService';

export function useFeedbackServiceWithMetadata() {
  const org = useOrganisation();
  const organisationName = org?.organisationName || 'Unknown';

  return useMemo(() => ({
    submit: (params) => {
      const authUser = getAuthPkgUser();
      let userIsImpersonated = 'unavailable';
      try {
        userIsImpersonated = authUser ? authUser.isImpersonating() : 'unavailable';
      } catch (e) {
        // Indicate metadata is unavailable if token inspection fails
        userIsImpersonated = 'unavailable';
      }

      return submitFeedback({
        ...params,
        metadata: {
          userIsImpersonated,
          userCompanyName: organisationName,
        },
      });
    },
  }), [organisationName]);
}
